import { languageNameInterpolations } from '@lessonnine/pidgin.js';

import { learnLanguages } from 'src/dataLayer/localData/learnLanguages';
import { LOCALE } from 'src/dataLayer/env';
// this file is generated by the script compile:language-combinations at build time
import learnLangOrder from 'src/config/learnLangOrder.json';
import { LearnLanguage } from 'src/types/learnLanguage';

const languageNameMapping: {[key: string]: string} = {
  en: 'italian-drop-down-menu',
  en_GB: 'Italian',
  de: 'Italienisch',
  fr: 'Italien',
  it: 'Italiano',
  es: 'Italiano',
  pl: 'włoski',
  pt: 'Italiano',
  sv: 'Italienska',
  uk: 'італійська'
};

const LIVE_LEARN_LANGUAGES = new Set(['ENG', 'SPA', 'DEU', 'ITA', 'FRA']);

export const getLanguageNameMapping = (locale = LOCALE): string =>
  languageNameMapping[locale];

const isLearnLanguageValid = (learnLanguage: LearnLanguage, locale: string): boolean => learnLanguage.alpha2 !== locale;

const mapLearnLangKeyToLearnLangData = (learnLanguageKey: string, locale: string): LearnLanguage => {
  const languageName = getLanguageNameMapping(locale);

  return { learnLanguage: learnLanguageKey,
    learnLanguageTranslation: languageNameInterpolations(
      { locale, learnLanguageAlpha3: learnLanguageKey }
    )[languageName],
    ...learnLanguages[learnLanguageKey] };
};

const isLiveLearnLanguage = (learnLanguage: LearnLanguage): boolean =>
  LIVE_LEARN_LANGUAGES.has(learnLanguage.learnLanguage);

export const getLanguageSelectionList = (isLiveFlow: boolean, locale = LOCALE): LearnLanguage[] => {
  const typedLearnLangOrder: {[key: string]: string[]} = learnLangOrder;

  const languageSelectionList = typedLearnLangOrder[locale]
    .map((language: string) => mapLearnLangKeyToLearnLangData(language, locale))
    .filter((learnLanguage: LearnLanguage) => isLearnLanguageValid(learnLanguage, locale));

  if (isLiveFlow) {
    return languageSelectionList.filter((learnLanguage: LearnLanguage) => isLiveLearnLanguage(learnLanguage));
  }
  return languageSelectionList;
};
